import Tooltip from 'tooltip.js';
import { merge } from 'lodash-es';

const DEFAULT_OPTIONS = {
  html: false,
  placement: 'top',
  container: 'body',
  popperOptions: {
    offsets: {},
  },
};

function mountTooltip(referenceElement, options = {}) {
  const rawTitle = referenceElement.getAttribute('title');
  // Vue 3 serializes `:title="false"` to the string "false" (Vue 2 dropped it);
  // treat the serialized falsy strings as no title.
  const title = ['false', 'null', 'undefined'].includes(rawTitle) ? null : rawTitle;
  // eslint-disable-next-line prototype-pollution-security-rules/detect-merge-objects
  const finalOptions = merge({}, DEFAULT_OPTIONS, { title }, options);

  // Prevents native browser title interfering with tooltip
  referenceElement.removeAttribute('title');
  // Keep title as data-title to be able to assert on tests
  referenceElement.dataset.title = title || '';

  if (!finalOptions.template) {
    const placementClass = finalOptions.placement; // TODO: Adapt top top-left, bottom-right, etc.

    // Forced 0 margin is needed to counter positioning differences between bootstrap/popper
    finalOptions.template = `
    <div class="vue-tooltip ${placementClass}">
      <div class="tooltip-arrow" style="margin: 0"></div>
      <div class="tooltip-inner"></div>
    </div>`;
  }

  referenceElement._v_tooltip = new Tooltip(referenceElement, finalOptions);
}

function destroyTooltip(referenceElement) {
  if (referenceElement._v_tooltip) {
    referenceElement._v_tooltip.dispose();
  }
}

// Vue 3 directive API
export default {
  mounted(el, binding) {
    if (binding.value !== false) {
      mountTooltip(el, binding.value);
    }
  },
  updated(el, binding) {
    if (!!binding.value && binding.oldValue === false) {
      mountTooltip(el, binding.value);
    }

    if (!!binding.oldValue && binding.value === false) {
      destroyTooltip(el);
    }
  },
  unmounted(el) {
    destroyTooltip(el);
  },
};
